import React from 'react';
import styled from 'styled-components';

export const DateFieldSC = styled.div`
  /* margin-right: 15px; */
`;
